// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__BeYTZ","addWidgetButton":"Header_addWidgetButton__3Tb_t","dashboardTabs":"Header_dashboardTabs__3xecc","active":"Header_active__2OPA0"};